export default __webpack_public_path__ + "static/og-00097e057ae31683393cba1eefa2d661.jpg";